import { configureStore } from '@reduxjs/toolkit';
import cache from './cache'

export const store = configureStore({
	reducer: {
		docData: cache
	},
})